const AVATAR_COLORS = [
  '#4fcdff', '#892ca3', '#ff9b1d', '#4ade80', '#f472b6',
  '#22d3d8', '#a78bfa', '#fbbf24', '#ef4444', '#6366f1',
];

/**
 *
 */
export function getInitials(name: string): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 *
 */
export function getAvatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
